import { render, staticRenderFns } from "./card-auth.vue?vue&type=template&id=15e8c5d6&scoped=true&"
import script from "./card-auth.vue?vue&type=script&lang=ts&"
export * from "./card-auth.vue?vue&type=script&lang=ts&"
import style0 from "./card-auth.vue?vue&type=style&index=0&id=15e8c5d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8c5d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
